import AntForm, { type AntSchema, useAntForm } from '@9troisquarts/ant-form'
import { Alert } from 'antd'
import React, { useState } from 'react'
import { type CustomerType } from '../../types'
import { castAttributesFromDefinition, type ModelDefinitionType } from '@9troisquarts/wand'
import axiosClient from '../../../utils/axiosClient'
import useI18n from '../../../utils/useI18n'

const customerDefinition: ModelDefinitionType = {
  email: 'String'
}

const ResetPassword: React.FC = () => {
  const { t } = useI18n()
  const { object, onChange } = useAntForm({})
  const [alertMessage, setAlertMessage] = useState<{ message: string, type: 'warning' | 'success' | 'info' | 'error' | undefined }>({
    message: t('sentences.reset_password_instructions'),
    type: 'warning'
  })
  const [errors, setErrors] = useState<any | undefined>(undefined)

  const resetPassword = async (customer: CustomerType) => {
    await axiosClient.post('/customers/password', {
      customer: { ...customer }
    }).then(() => {
      setAlertMessage({ message: t('sentences.reset_password_success'), type: 'success' })
    }).catch(err => {
      setErrors(err.errors)
    })
  }

  const onSubmit = (): void => {
    const email = String(object.email || '').trim()
    if (!email) {
      setErrors({ email: [t('sentences.auth_field_required')] })
      setAlertMessage({ message: t('sentences.auth_fields_required'), type: 'error' })
      return
    }

    void resetPassword(castAttributesFromDefinition(customerDefinition, object))
  }

  const handleChange = (...args: any[]) => {
    onChange(...args)
    if (errors) setErrors(undefined)
    if (alertMessage.type === 'error') {
      setAlertMessage({ message: t('sentences.reset_password_instructions'), type: 'warning' })
    }
  }

  const ResetPasswordSchema: AntSchema = [
    {
      name: 'email',
      label: t('words.email'),
      required: true,
      input: {
        type: 'string'
      },
      colProps: {
        xs: 24,
        md: 24
      }
    }
  ]

  return (
    <div>
      <div className='home-panel-alert'>
        <Alert type={alertMessage.type} message={alertMessage.message} />
      </div>
      <AntForm
        schema={ResetPasswordSchema}
        object={object}
        layout="vertical"
        errors={errors}
        onChange={handleChange}
        onSubmit={onSubmit}
        onFinishFailed={() => {
          setErrors({ email: [t('sentences.auth_field_required')] })
          setAlertMessage({ message: t('sentences.auth_fields_required'), type: 'error' })
        }}
        submitText={t('sentences.reset_password')}
        className='auth-form'
        actionsWrapperProps={{
          className: 'auth-form-actions'
        }}
        submitButtonProps={{
          className: 'primary-btn'
        }}
      />
    </div>
  )
}

export default ResetPassword
